<form #f="ngForm" (ngSubmit)="onSubmit(f,search)">
    <div class="search-container my-3">
        <div class="search-bar">
            <input type="text" name="search" #search="ngModel" ngModel class="search-bar__input" autocomplete="off"
                placeholder="Buscar megatendencias, tendencias, riesgos, oportunidades y más..." minlength="3" maxlength="40" pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]+$"
                (keyup)="term$.next($event.target.value)" />
            <button class="search-bar__submit">
                <i class="icon-edit fa fa-search"></i>
            </button>
        </div>
    </div>
    <div class="row ml-1">
        <small *ngIf="search.errors" class="validation-result">
            <span [hidden]="!search.errors.maxlength">
                La búsqueda debe tener como máximo 40 caracteres.<br />
            </span>
            <span [hidden]="!search.errors.minlength">
                La búsqueda debe tener al menos 3 caracteres.<br />
            </span>
            <span [hidden]="!search.errors.pattern">
                La búsqueda no debe tener caracteres especiales.
            </span>
        </small>
    </div>
</form>